import React from "react";

export default function statusPublicatie(color) {
    return (<svg id="Laag_2" viewBox="0 0 51 51" width="51px" height="80px">
        <g transform="matrix(1.2,0,0,-1.2,0,45)">
            <g transform="scale(0.1)">
                <path fill="none" stroke="#006FB7" strokeWidth="5"
                    d="M 322.434,5 H 77.6523 C 37.5898,5 5,37.5898 5,77.6563 c 0,38.6917 30.3906,70.4097 68.5586,72.5387 -4.8281,11.309 -7.2695,23.285 -7.2695,35.7 0,50.511 41.0939,91.605 91.6129,91.605 45.352,0 83.172,-32.52 90.36,-76.609 6.437,2.367 13.144,3.562 20.027,3.562 30.871,0 56.262,-23.969 58.52,-54.269 38.035,-2.274 68.289,-33.934 68.289,-72.5277 C 395.098,37.5898 362.5,5 322.434,5 Z" />
                <path fill="none" stroke="#006FB7" strokeWidth="5"
                    d="m 106.938,209.172 h 93.437 l 37.723,-37.07 V 55.3438 c 0,0 3.476,-25.0313 -22.864,-25.0313 -16.687,0 -108.074,0 -108.074,0 0,0 -0.222,179.2925 -0.222,178.8595 z" />
                <path fill="none" stroke="#006FB7" strokeWidth="5"
                    d="m 237.715,171.914 h -37.086 v 37.082" />
            </g>
        </g>
    </svg>);
}